import { Modal, Form, Rate, Input } from 'antd';
import { useIntl } from 'react-intl';
import Icon from '@ant-design/icons';
import { useState } from 'react';
import dayjs from 'dayjs';

import { ratePickup } from 'services/pickups';
import { useModal } from 'contexts/modalProvider.context';

import BRButton from 'components/BRButton/BRButton';
import RateConfirmationModal from 'components/Pickups/components/RatePickupServiceModal/components/RateConfirmationModal/RateConfirmationModal';
import { notify } from 'components/Notify/Notify';

import { ReactComponent as PickupIcon } from 'assets/bosta-icons/Pickups.svg';

import './RatePickupServiceModal.less';

const RatePickupServiceModal = ({
  close,
  pickupId,
  pickedupDate,
  ...props
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { openModal } = useModal();

  const intl = useIntl();

  const onFinish = async (values) => {
    setIsLoading(true);

    try {
      await ratePickup({ pickupId, payload: { ...values } });
      openModal(RateConfirmationModal);
      close();
    } catch (error) {
      notify({ msg: error.message, error });
    }

    setIsLoading(false);
  };

  return (
    <Modal
      title={intl.formatMessage({ id: 'rate_pickup_service_modal.title' })}
      wrapClassName="br-rate-pickup-service__modal"
      footer={
        <>
          <BRButton
            label={intl.formatMessage({ id: 'common.cancel' })}
            onClick={close}
          />
          <BRButton
            type="primary"
            loading={isLoading}
            label={intl.formatMessage({ id: 'common.submit' })}
            form="ratePickupServiceForm"
            htmlType="submit"
          />
        </>
      }
      {...props}
    >
      <div className="br-rate-pickup-service__pickup-details__banner">
        <Icon component={PickupIcon} className="ant-icon-lg" />
        <div>
          <div className="body-medium">
            {intl.formatMessage(
              { id: 'rate_pickup_service_modal.pickup_id' },
              {
                pickupId
              }
            )}
          </div>
          <div className="br-rate-pickup-service__pickup-details__date caption">
            {dayjs(pickedupDate).format('MM/DD/YYYY hh:mm A')}
          </div>
        </div>
      </div>
      <Form onFinish={onFinish} name="ratePickupServiceForm">
        <Form.Item
          name="starRating"
          rules={[{ required: true }]}
          label={intl.formatMessage({
            id: 'rate_pickup_service_modal.form_labels.rate_star'
          })}
        >
          <Rate />
        </Form.Item>
        <Form.Item
          name="starComment"
          label={
            <>
              <span>
                {intl.formatMessage({
                  id: 'rate_pickup_service_modal.form_labels.rate_comment'
                })}
              </span>
              <span className="br-form-optional-label">
                {intl.formatMessage({
                  id: 'form.optional_label'
                })}
              </span>
            </>
          }
        >
          <Input.TextArea
            autoSize={{ minRows: 3, maxRows: 3 }}
            maxLength={500}
          />
        </Form.Item>
        <Form.Item
          name="serviceRating"
          rules={[{ required: true }]}
          label={intl.formatMessage({
            id: 'rate_pickup_service_modal.form_labels.rate_experience'
          })}
        >
          <Rate />
        </Form.Item>
        <Form.Item
          name="serviceComment"
          label={
            <>
              <span>
                {intl.formatMessage({
                  id: 'rate_pickup_service_modal.form_labels.rate_comment'
                })}
              </span>
              <span className="br-form-optional-label">
                {intl.formatMessage({
                  id: 'form.optional_label'
                })}
              </span>
            </>
          }
        >
          <Input.TextArea
            autoSize={{ minRows: 3, maxRows: 3 }}
            maxLength={500}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RatePickupServiceModal;
